import { Sigma, BookOpenText, Boxes, Compass, ListOrdered, ScanEye, Lightbulb, Brain } from "lucide-react";

const APTITUDE_TYPES = [
  { name: "Numerical Reasoning", icon: Sigma },
  { name: "Vocabulary", icon: BookOpenText },
  { name: "Inductive Reasoning", icon: Boxes },
  { name: "Spatial Visualization", icon: Compass },
  { name: "Sequential Reasoning", icon: ListOrdered },
  { name: "Visual Comparison Speed", icon: ScanEye },
  { name: "Idea Generation", icon: Lightbulb },
  { name: "Work Approach Style", icon: Brain },
];

export function MultiDimensionalAptitude() {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-[#151233] via-[#1E1B4B] to-[#0F0D24] text-white" data-testid="multidimensional-aptitude-section">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs uppercase tracking-[0.25em] font-medium text-cyan-300 mb-3 text-center">Beyond Interest-Based Matching</p>
        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-center mb-4">Multi-Dimensional Aptitude Testing</h2>
        <p className="text-slate-300 text-center max-w-2xl mx-auto mb-12 leading-relaxed">
          Most assessments stop at preferences and personality. CareerStudy360 adds a separate, performance-based
          Aptitude Test across 8 dimensions — reinforcing your report with objective reasoning and ideation data,
          not just self-reported opinions.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {APTITUDE_TYPES.map((t) => {
            const Icon = t.icon;
            return (
              <div key={t.name} data-testid={`landing-aptitude-chip-${t.name.split(" ")[0].toLowerCase()}`} className="rounded-2xl border border-white/10 bg-white/5 p-5 hover:bg-white/10 transition-colors duration-300">
                <span className="h-9 w-9 rounded-xl bg-cyan-500/15 flex items-center justify-center mb-3">
                  <Icon className="h-4.5 w-4.5 text-cyan-300" />
                </span>
                <p className="text-sm font-semibold text-white">{t.name}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
